"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4387],{

/***/ 64387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ carousel_asset_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/carousel.js + 3 modules
var carousel = __webpack_require__(28391);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/default-props.js
var default_props = __webpack_require__(26687);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/default-props.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var carousel_asset_default_props = (_object_spread({}, default_props/* default */.Z));

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/carousel-asset-component.scss.js

var StyledCarouselAssetComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4rjho20"
})("margin:auto;&.default-style{.carousel{.slick-slider{&.focus{.slick-list{.slick-track{.slick-slide{.carousel-item{opacity:1;padding:0 var(--image-padding);.picture-component{height:100%;width:100%;}}&.slick-center.slick-active{.carousel-item{transform:scale(1);}}}}}}.slick-list{.slick-track{display:flex;padding-top:0;.slick-slide{opacity:1;transition:opacity 0.5s ease-in-out;height:auto;> div:first-child{height:100%;}}.carousel-item{height:100%;display:flex;justify-content:center;align-items:center;}}}}}.image-slide{height:var(--image-height,100%);}}.image-slide{cursor:grab;width:100%;height:auto;object-fit:contain;}");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/carousel-asset-component.js
function carousel_asset_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_asset_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_asset_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}









var CarouselAssetComponent = function(_param) {
    var autoplay = _param.autoplay, imageHeight = _param.imageHeight, horizontalPadding = _param.horizontalPadding, slides = _param.slides, centerPadding = _param.centerPadding, disableCenterModeStyle = _param.disableCenterModeStyle, pauseOnHover = _param.pauseOnHover, transitionSpeed = _param.transitionSpeed, rest = _object_without_properties(_param, [
        "autoplay",
        "imageHeight",
        "horizontalPadding",
        "slides",
        "centerPadding",
        "disableCenterModeStyle",
        "pauseOnHover",
        "transitionSpeed"
    ]);
    var assets = (0,react.useMemo)(function() {
        return (slides || []).map(function(slide) {
            var _slide_asset;
            return slide === null || slide === void 0 ? void 0 : (_slide_asset = slide.asset) === null || _slide_asset === void 0 ? void 0 : _slide_asset.image;
        });
    }, [
        slides
    ]);
    var isUserSlideRef = (0,react.useRef)(null);
    var slider = (0,react.useRef)(null);
    var currentIndex = (0,react.useRef)(0);
    var pauseCarouselOnEvent = (0,react.useCallback)(function() {
        var _slider_current;
        return pauseOnHover && autoplay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.slickPause());
    }, [
        autoplay,
        pauseOnHover
    ]);
    var onItemClick = (0,react.useCallback)(function(event, slideIndex) {
        if (slideIndex !== currentIndex.current) {
            isUserSlideRef.current = true;
        }
        if (slideIndex === 0 && currentIndex.current === assets.length - 1) {
            var _slider_current;
            (_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.slickNext();
            event.stopPropagation();
        }
        if (slideIndex === assets.length - 1 && currentIndex.current === 0) {
            slider.current.slickPrev();
            event.stopPropagation();
        }
    }, [
        assets
    ]);
    var itemRenderer = (0,react.useCallback)(function(image, index) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onClick: function(event) {
                return onItemClick(event, index);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                className: "image-slide",
                src: image === null || image === void 0 ? void 0 : image.src,
                alt: image === null || image === void 0 ? void 0 : image.alt
            }, image === null || image === void 0 ? void 0 : image.src)
        });
    }, [
        onItemClick
    ]);
    var onSlideSwipe = (0,react.useCallback)(function() {
        isUserSlideRef.current = true;
        pauseCarouselOnEvent();
    }, [
        pauseCarouselOnEvent
    ]);
    var onSlideChange = (0,react.useCallback)(function(index) {
        if (isUserSlideRef.current) {
            var _assets_index;
            (0,bigbrain_service.trackEvent)(bigbrain_event_types.CAROUSEL_USER_SWIPE, {
                kind: (_assets_index = assets[index]) === null || _assets_index === void 0 ? void 0 : _assets_index.src,
                info1: index
            });
            isUserSlideRef.current = false;
        }
    }, [
        assets
    ]);
    var carouselProps = (0,react.useMemo)(function() {
        return {
            items: assets,
            autoplay: autoplay,
            beforeChange: function(oldIndex, newIndex) {
                currentIndex.current = newIndex;
            },
            onRefSet: function(ref) {
                slider.current = ref;
            },
            pauseOnHover: pauseOnHover,
            itemRenderer: itemRenderer,
            speed: transitionSpeed,
            defaultIndex: 0,
            onChange: onSlideChange,
            onSwipe: onSlideSwipe,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: centerPadding || undefined,
            swipeToSlide: true
        };
    }, [
        assets,
        autoplay,
        centerPadding,
        itemRenderer,
        onSlideChange,
        onSlideSwipe,
        pauseOnHover,
        transitionSpeed
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCarouselAssetComponent, {
        onMouseEnter: pauseCarouselOnEvent,
        onMouseLeave: function() {
            var _slider_current;
            return pauseOnHover && autoplay && ((_slider_current = slider.current) === null || _slider_current === void 0 ? void 0 : _slider_current.slickPlay());
        },
        className: classnames_default()("carousel-asset-component", {
            "default-style": disableCenterModeStyle
        }),
        style: {
            "--image-height": imageHeight,
            "--image-padding": horizontalPadding
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(carousel/* default */.Z, carousel_asset_component_object_spread({}, rest, carouselProps))
    });
};
CarouselAssetComponent.defaultProps = carousel_asset_default_props;
/* harmony default export */ var carousel_asset_component = (CarouselAssetComponent);


/***/ })

}]);